import React from "react"
import ProjectIconUI5 from "../../../../../core/gd-components/icons/project/project-icon-ui5";

export default function menuAdd_getProjectTemplates(templates: any[], onAddSubproject: func, onAddFromLibrary: func) {

    const isManager = gd.ac.check.company.isManager()

    const onManageProjectTemplates = () => {
        gd.goTo('settings/templates')
    }

    const templatesOptions: any = []


    _.map(templates, template=> {
        if (template.typeId === 'workfolder') return
        templatesOptions.push({
            // icon    : template.icon,
            iconComponent: <ProjectIconUI5 className="m-r-12" projectId={template.id}/>,
            label   : template.title,
            onClick : ()=>onAddSubproject(template.id)
        })
    })
    templatesOptions.push({type: 'separator'})

    if (isManager) {
        templatesOptions.push({
            icon        : "i5-wrench",
            label       : "Manage templates",
            onClick     : onManageProjectTemplates
        })
    }

    templatesOptions.push({
        icon    : 'i5-templates',
        label   : 'Templates library',
        onClick : ()=>onAddFromLibrary()
    })

    return templatesOptions
}
